import { State } from 'modules';

import { APISettingName } from 'types/api';

export const emailTemplate = (state: State) => state.settings.emailTemplate;

export const isEmailTemplateReady = (state: State) =>
  state.settings.isEmailTemplateReady;

export const selectedTemplateBlockId = (state: State) =>
  state.settings.selectedBlockId;

export const selectedSidebarTab = (state: State) =>
  state.settings.selectedSidebarTab;

export const selectedScreenSize = (state: State) =>
  state.settings.selectedScreenSize;

export const selectedMainTab = (state: State) => state.settings.selectedMainTab;
export const selectedTemplate = (state: State) =>
  state.settings.selectedTemplate;

export const loadCheckTemplatePending = (state: State) =>
  state.settings.loadCheckTemplatePending;

export const saveCheckTemplatePending = (state: State) =>
  state.settings.saveCheckTemplatePending;

export const generalSettings = (state: State) => state.settings.generalSettings;

export const loadSettingsPending = (state: State) =>
  state.settings.loadSettingsPending;

export const saveSettingPending = (state: State) =>
  state.settings.saveSettingPending;

export const eCheckPrintLimit = (state: State) => {
  const setting = state.settings.generalSettings.find(
    setting => setting.name === 'ECheckPrintLimit',
  );
  return +(setting?.value || 1);
};

export const loadEmailTemplatePending = (state: State) =>
  state.settings.loadEmailTemplatePending;

export const getSettingValue =
  (name: APISettingName, defaultValue: string) => (state: State) => {
    const settings = generalSettings(state);
    const setting = settings.find(setting => setting.name === name);
    return setting?.value || defaultValue;
  };
